import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

export function EnrollNowPath() {
    const enrollInfo = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration.partnerConfig) {
            return {
                isEnrollmentAvailable: state.configurationState.configuration.partnerConfig.isEnrollmentAvailable,
                enrollNowPath: state.configurationState.configuration.partnerConfig.enrollNowPath,
                originSiteUrl: state.configurationState.configuration.partnerConfig.originSiteUrl,
            };
        } else {
            return {
                isEnrollmentAvailable: false,
                enrollNowPath: "",
                originSiteUrl: "",
            };
        }
    });

    let enrollNowPathURL = "javascript:void(0)";

    if (enrollInfo.originSiteUrl) {
        if (enrollInfo.originSiteUrl.endsWith("/")) {
            enrollNowPathURL = enrollInfo.originSiteUrl.slice(0, -1);
        } else {
            enrollNowPathURL = enrollInfo.originSiteUrl;
        }

        if (enrollInfo.enrollNowPath) {
            if (enrollInfo.enrollNowPath.startsWith("/")) {
                enrollNowPathURL = enrollNowPathURL + enrollInfo.enrollNowPath;
            } else if (enrollInfo.enrollNowPath.startsWith("https://")) {
                enrollNowPathURL = enrollInfo.enrollNowPath;
            } else {
                enrollNowPathURL = enrollNowPathURL + "/" + enrollInfo.enrollNowPath;
            }
        }

        if (!enrollNowPathURL.startsWith("https://") && !enrollNowPathURL.startsWith("http://")) {
            enrollNowPathURL = "https://" + enrollNowPathURL;
        }
    }

    return enrollNowPathURL;
}
